import Vue from 'vue'
import axios from 'axios'
import { Subject } from 'rxjs'

// 各コンポーネントからアクセスするときの名前登録（テンプレ）
Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.longQuery) this.$longQuery = options.longQuery
    else if (options.parent && options.parent.$longQuery)
      this.$longQuery = options.parent.$longQuery
  },
})

const storage = sessionStorage
const lastingStorage = localStorage
const subject = new Subject()

export default {
  connect() {
    // NOP
  },
  observable: subject.asObservable(),
  saveQueryFilter(queryId, queryFilter) {
    return new Promise(r => {
      storage.setItem(
        `giggle.queryfilter.${queryId}`,
        JSON.stringify(queryFilter),
      )
      r(queryId)
    })
  },
  saveMenuQueryFilter(resourceName, queryFilter) {
    lastingStorage.setItem(
      `giggle.queryfilter.${resourceName}.latest`,
      JSON.stringify(queryFilter),
    )
    return Promise.resolve(undefined)
  },
  fetchMenuQueryFilter(menuCode) {
    const queryFilter = lastingStorage.getItem(
      `giggle.queryfilter.${menuCode}.latest`,
    )

    if (queryFilter) {
      return Promise.resolve(JSON.parse(queryFilter))
    } else {
      return Promise.resolve(undefined)
    }
  },
  fetchQueryFilter(queryId) {
    return new Promise(r => {
      r(JSON.parse(storage.getItem(`giggle.queryfilter.${queryId}`)))
    })
  },
  executeQuery(resourceName) {
    // eslint-disable-next-line no-console
    console.log('execute query')
    const id = new Date().getTime().toString()

    setTimeout(async () => {
      let grid = { colModel: undefined, groupHeader: undefined }
      try {
        const response = await axios.get(`/query/${resourceName}/grid.json`)
        grid = response.data
      } catch (error) {
        if (error.response.status) {
          // eslint-disable-next-line no-console
          console.log(
            'no dummy grid definition at ',
            `/query/${resourceName}/grid.json`,
          )
        }
      }
      subject.next({
        id,
        status: 'Completed',
        grid,
      })
    }, 1500)

    return new Promise(r => {
      r({ id, status: 'Working' })
    })
  },
  fetchQueryInfo(resourceName, queryId) {
    return new Promise(r => {
      setTimeout(async () => {
        let grid = { colModel: undefined, groupHeader: undefined }
        try {
          const response = await axios.get(`/query/${resourceName}/grid.json`)
          grid = response.data
        } catch (error) {
          if (error.response.status) {
            // eslint-disable-next-line no-console
            console.log(
              'no dummy grid definition at ',
              `/query/${resourceName}/grid.json`,
            )
          }
        }

        r({
          queryId,
          status: 'Completed',
          grid,
          hasData: true,
        })
      }, 500)
    })
  },
  getQueryResultFetchUrl(resourceName, queryId, path) {
    return `/query/${resourceName}/${path}/data.json`
  },
  getColModelFetchUrl(resourceName, queryId, path) {
    return `/query/${resourceName}/${path}/grid.json`
  },
}
